import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { device } from '../../../utils/helpers'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import styled from 'styled-components'

const StyledNextArrow = styled.div`
  &:before {
    border: solid white;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 6px;
    transform: rotate(-45deg);
    content:  '' !important;
  }

  @media ${device.tablet} {
    &:before {
      padding: 12px;
    }
  }
`

const StyledPrevArrow = styled.div`
  &:before {
    border: solid white;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 6px;
    transform: rotate(135deg);
    content:  '' !important;
  }

  @media ${device.tablet} {
    &:before {
      padding: 12px;
    }
  }
`

// Arrow Overrides
const NextArrow = (props) => {
  const { className, style, onClick } = props
  return (
    <StyledNextArrow
      className={className}
      style={{ ...style, display: 'block', color: '#000', right: '20px', zIndex: 50 }}
      onClick={onClick}
    />
  )
}

const PrevArrow = (props) => {
  const { className, style, onClick } = props
  return (
    <StyledPrevArrow
      className={className}
      style={{ ...style, display: 'block', color: '#000', left: '10px', zIndex: 50 }}
      onClick={onClick}
    />
  )
}

class ReactSlider extends Component {
  render () {
    const { slides, dots, autoplay } = this.props
    const settings = {
      dots: dots,
      dotsClass: 'slick-dots',
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
      // autoplay: autoplay
    }
    return (
      <Slider ref={slider => (this.slider = slider)} {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            {slide}
          </div>
        ))}
      </Slider>
    )
  }
}

ReactSlider.propTypes = {
  /**
   * Slides for the slider
   */
  slides: PropTypes.array.isRequired,
  /**
   * Show or hide dots
   */
  dots: PropTypes.bool
}

ReactSlider.defaultProps = {
  dots: true
}

export default ReactSlider



// WEBPACK FOOTER //
// ./src/components/UI/Slider/index.js